import { Button, CircularProgress } from "@material-ui/core";
import { useUsers } from "../../../graphql/hooks";
// import { useLoggedUserInfo } from "../../../hooks";

export type GenerateUsersLatestPrivacyReportProps = {};
export function GenerateUsersLatestPrivacyReport(
  _props: GenerateUsersLatestPrivacyReportProps
) {
  const {
    createUsersLatestPrivacyReport,
    createUsersLatestPrivacyReportLoading,
  } = useUsers({
    onUsersLatestPrivacyReportCreated(attachment) {
      window.open(attachment.url);
    },
  });

  return (
    <Button
      disabled={createUsersLatestPrivacyReportLoading}
      onClick={() => createUsersLatestPrivacyReport()}
    >
      {!createUsersLatestPrivacyReportLoading &&
        "Scarica report preferenze privacy"}
      {createUsersLatestPrivacyReportLoading && <CircularProgress />}
    </Button>
  );
}
